module.exports = __webpack_public_path__ + "static/img/arthroscopy-20.264e333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-20.jpg
// module id = wsjK
// module chunks = 51